import React from 'react';
import { Star, Quote, Calendar } from 'lucide-react';
import { Card } from './ui/card';

export const Testimonials = () => {
  const reviews = [
    {
      name: "Jamshaid",
      rating: 5,
      text: "Had minor servicing done of my gmc sierra and it was great experience they owner is good guy knowledgeable and knows where to find even after market parts highly recommended",
      date: "Yesterday"
    },
    {
      name: "Vijay Krishnan",
      rating: 5,
      text: "I highly recommend Mr. Sultan from Think Mechanic in Dubai. I drove my 2018 BMW X5 in a flood, and a persistent jerking issue emerged. I initially went to a reputed garage nearby, where they insisted on changing the ignition coils and spark plugs, the usual suspects. However, the major jerk remained, only reducing to a minor one after I insisted they calibrate the VTG. They were clueless after that and again demanded changing the expensive 4x4 motor. That's when a friend suggested Mr. Sultan at Think Mechanic. He patiently listened to my entire story, test drove my car twice, and scanned it for errors. Crucially, he didn't push for costly repairs but advised driving it for two days, trusting the VTG to fix itself. And it did! He's a true car expert with genuine passion.",
      date: "6 days ago"
    },
    {
      name: "Sagar Bhavnani",
      rating: 5,
      text: "Honestly, I had a really good experience at Think Mechanic Garage. I went in expecting the usual hassle you get with car repairs, but Sultan made the whole process super smooth and stress-free. He actually took the time to explain what was wrong with my car and suggested the most cost-effective way to fix it, instead of pushing for expensive or unnecessary work. He saved me almost AED 5,000. That kind of honesty is hard to come by. The job was done well, on time, and I left feeling like I made the right choice. You can tell they genuinely care about their customers. Definitely recommending Think Mechanic Garage to anyone looking for a reliable and trustworthy place. Ask for Sultan 👍",
      date: "1 week ago"
    },
    {
      name: "Sheraz Ilyas",
      rating: 5,
      text: "I owned a Mercedes E350, and changing the transmission (gear) fluid isn't an easy job because of the electronic gearbox. Around 90% of the garages I visited advised me not to change it, saying it could actually reduce performance or cause issues. Then I came across a true expert the OG of German cars think Mechanic garage in ras al khor Dubai. He did a thorough inspection of the car, changed the transmission fluid properly, and even test drove it for at least 30 minutes to make sure everything was perfect. And the result? Absolutely amazing. The gear shifting became smoother than ever before, and the car felt great to drive. If you're a German car lover, this is definitely a garage you can trust.",
      date: "2 weeks ago"
    }
  ];

  const renderStars = (rating) => {
    return (
      <div className="flex space-x-1">
        {[...Array(5)].map((_, index) => (
          <Star
            key={index}
            className={`w-5 h-5 ${
              index < rating ? 'fill-yellow-500 text-yellow-500' : 'text-gray-600'
            }`}
          />
        ))}
      </div>
    );
  };

  return (
    <section className="py-20 bg-gray-50 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-red-600 font-semibold text-sm uppercase tracking-wider">Customer Reviews</span>
          
          {/* Google Rating Highlight */}
          <div className="mt-6 mb-4 w-full flex justify-center">
            <div className="flex flex-col sm:flex-row items-center sm:space-x-4 space-y-3 sm:space-y-0 bg-gradient-to-r from-red-600 to-red-700 px-6 sm:px-8 py-6 sm:py-4 rounded-2xl shadow-2xl w-full sm:w-auto max-w-md sm:max-w-none">
              <div className="text-center">
                <div className="flex items-center justify-center space-x-3 mb-1">
                  <span className="text-5xl sm:text-6xl font-black text-white">4.8</span>
                  <div className="text-left">
                    <div className="flex space-x-0.5">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className="w-5 h-5 sm:w-6 sm:h-6 fill-yellow-400 text-yellow-400" />
                      ))}
                    </div>
                    <span className="text-white text-xs sm:text-sm font-semibold whitespace-nowrap">out of 5</span>
                  </div>
                </div>
              </div>
              
              <div className="hidden sm:block h-12 w-px bg-white/30"></div>
              
              <div className="text-center">
                <div className="text-4xl sm:text-5xl font-black text-white">300+</div>
                <div className="text-white text-xs sm:text-sm font-semibold whitespace-nowrap">Google Reviews</div>
              </div>
            </div>
          </div>

          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mt-6 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Real reviews from real customers. See why we're Dubai's most trusted German car specialists.
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {reviews.map((review, index) => (
            <Card
              key={index}
              className="bg-white border-gray-200 p-8 hover:border-red-600 transition-all duration-300 relative overflow-hidden group shadow-sm"
            >
              {/* Quote Icon */}
              <div className="absolute top-4 right-4 opacity-10 group-hover:opacity-20 transition-opacity">
                <Quote className="w-16 h-16 text-red-600" />
              </div>

              {/* Header */}
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h4 className="text-gray-900 font-bold text-xl mb-2">{review.name}</h4>
                  {renderStars(review.rating)}
                </div>
                
                {/* Google Logo */}
                <div className="flex items-center space-x-2">
                  <svg className="w-6 h-6" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                  <span className="text-gray-400 text-xs font-semibold">Google</span>
                </div>
              </div>

              {/* Review Text */}
              <p className="text-gray-600 leading-relaxed mb-4 relative z-10">
                "{review.text}"
              </p>

              {/* Date */}
              <div className="flex items-center space-x-2 text-gray-500 text-sm">
                <Calendar className="w-4 h-4" />
                <span>{review.date}</span>
              </div>
            </Card>
          ))}
        </div>

        {/* Google Reviews Link */}
        <div className="text-center mt-12">
          <a
            href="https://share.google/y3vekVB7QIZPUQbC0"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-gray-900 hover:bg-gray-800 text-white font-semibold px-8 py-4 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span>Read All Reviews on Google</span>
          </a>
        </div>
      </div>
    </section>
  );
};
